window.path = require('core-js/es');
window.$ = global.jQuery = require('jquery');
//require('jquery-confirm');
require('bootstrap');
require('bootstrap-select');
window._ = require('lodash');
//window.bootbox = require('bootbox');